import { render, staticRenderFns } from "./LaborProtectionRating.vue?vue&type=template&id=474c093c&"
import script from "./LaborProtectionRating.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionRating.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionRating.vue?vue&type=style&index=0&id=474c093c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports